import PropTypes from "prop-types";

export const renderGridLabelColumn = (rowData, col, rowIndex) => {

  const { getLableClass } = col.colSettings

  const columnValue = rowData?.[col.fieldName];
  const displayVal = columnValue?.toString().toLowerCase();
  const cssClass = getLableClass(rowData?.[col.fieldName])



  let labelText = "";
  if (displayVal === "yes" || displayVal === "true" || displayVal === "active") {
    labelText = "Active";
  } else {
    labelText = "Inactive";
  }

  return (
    <span className={cssClass}>{labelText}</span>
  );
};

renderGridLabelColumn.propTypes = {
  rowData: PropTypes.object.isRequired,
  col: PropTypes.shape({
    fieldName: PropTypes.string.isRequired,
    colSettings: PropTypes.shape({
      getLableClass: PropTypes.func.isRequired,
    }).isRequired,
  }).isRequired,
  rowIndex: PropTypes.number.isRequired,
};